import { render } from "./Junction19Project.vue?vue&type=template&id=417b1880&scoped=true"
const script = {}

import "./Junction19Project.vue?vue&type=style&index=0&id=417b1880&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417b1880"]])

export default __exports__